/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * CheckoutDisabledButtonState Input Action
 */
export class CheckoutChargesStateInput implements Msdyn365.IActionInput {
    constructor() {}
    public getCacheKey = () => `checkoutCharges`;
    public getCacheObjectType = () => 'checkoutCharges';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface ICheckoutDeliveryFeeStateData {
    deliveryFee: number;
    taxAmount: number;
    recycleFee: number;
    totalAmount: number;
    subtotalAmount: number;
    checkoutSavings: number;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CheckoutChargesStateInput();
};

async function action(input: CheckoutChargesStateInput, ctx: Msdyn365.IActionContext): Promise<ICheckoutDeliveryFeeStateData> {
    return { deliveryFee: 0, taxAmount: 0, recycleFee: 0, totalAmount: 0, subtotalAmount: 0, checkoutSavings: 0 };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICheckoutDeliveryFeeStateData>>action,
    id: 'CheckoutDeliveryFeeState',
    input: createInput
    // isBatched: true
});
